import { CheckIcon, InfoIcon } from "@chakra-ui/icons";
import { Box, Button, Flex } from "@chakra-ui/react";
import { CustomModal, CustomModalProps } from "components/custom-modal";
import { useState } from "react";
import { useEventListener, makeEvent } from "services/events";

interface ModalInfoOptions {
  title?: string;
  message?:
    | string
    | JSX.Element
    | (({ onClose }: { onClose: () => void }) => string | JSX.Element);
  onClose?: () => any;
  modalProps?: Partial<CustomModalProps>;
}

export function ModalInfo() {
  const [modalInfoData, setModalInfoData] = useState<null | ModalInfoOptions>(
    null
  );
  useEventListener("open-modal-info", (options: ModalInfoOptions) => {
    setModalInfoData(options);
  });

  function onClose() {
    setModalInfoData(null);
    modalInfoData?.onClose?.();
  }

  return (
    <CustomModal
      isOpen={modalInfoData !== null}
      onClose={onClose}
      modalTitle={
        <Flex alignItems="center">
          <Box mr="8px" transform="translateY(-2px)">
            <InfoIcon color="primary.300" w="20px" h="20px" />
          </Box>
          {modalInfoData?.title ?? "Informação"}
        </Flex>
      }
      modalFooter={
        <Button leftIcon={<CheckIcon />} variant="outline" onClick={onClose}>
          OK
        </Button>
      }
      size={"xl"}
      {...modalInfoData?.modalProps}
    >
      <Flex alignItems="center">
        <Box>
          {typeof modalInfoData?.message === "function"
            ? modalInfoData.message({ onClose })
            : modalInfoData?.message
            ? modalInfoData.message
            : ""}
        </Box>
      </Flex>
    </CustomModal>
  );
}

export function openModalInfo(options: ModalInfoOptions) {
  makeEvent("open-modal-info", options);
}
